import { ChartQuestionAnswersResponseType } from "../types/chartQuestionAnswersInfoType";

export const getAverageScore = (data: ChartQuestionAnswersResponseType): number => {
  let totalScore = 0;
  let count = 0;

  data.forEach((question) => {
    question.answers.forEach((answer) => {
      const score = parseFloat(answer.answerMessage);
      if (!isNaN(score)) {
        totalScore += score * answer.answerCount;
        count += answer.answerCount;
      }
    });
  });

  return count > 0 ? totalScore / count : 0;
};
